/*
Plywood

--moistureResistant <boolean::checkbox>
--fireRated <boolean::checkbox>
--weight <float> | lbs/sqft | (per sheet, by lbs/sqft)
--manufacturers {
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
}
*/
import { type } from '@/modules/standardItems/schemas/baseHeaders'

import {
  moistureResistant,
  fireRated,
  sheetStockHeaders
} from '@/modules/standardItems/schemas/sheetStock/headers'

export default [
  type(),
  ...sheetStockHeaders(),
  fireRated(),
  moistureResistant(),
  {
    text: 'Weight (lbs/sqft)',
    value: 'weight',
    sortable: true,
    sort: 'number',
    unit: 'lbs/sqft'
  }
]
